<template>
    <div>
        <PullContainer
            ref="pullContainerRef"
            :pullDownLoading="true"
            :pullDownLabel="true"
            @pullDownLoadingSuccess="pullDownLoadingSuccess"
        >
            <template #container>
                <div class="public_container">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
                        <div class="returnNavBarRight" v-if="status == '1'">
                            <span @click="handleClickBatch">批量操作</span>
                        </div>
                    </div>
                    <div class="top_search">
                        <van-search
                            v-model="searchForm.keyword"
                            placeholder="请输入查询内容"
                            @search="onSearch"
                            @clear="onSearch"
                        >
                            <template #right-icon>
                                <i
                                    class="iconfont icon-shaixuan"
                                    v-if="status != 4"
                                    @click="handleClickAdvancedFilter"
                                ></i>
                            </template>
                        </van-search>
                    </div>
                    <div class="all_menu_list">
                        <ul>
                            <li
                                v-for="item in sourceList"
                                :key="item.status"
                                :class="{ active: status == item.status }"
                                @click="handleClickStatusChange(item)"
                            >
                                <span>{{ item.name }}</span>
                                <i class="count" v-if="item.count">{{ item.count > 99 ? "99+" : item.count }}</i>
                            </li>
                        </ul>
                        <div class="all_menu_filter_icon" @click="handleClickCategoryPickerShow">
                            <img
                                src="https://download.hecoos.com/enlightv/2024-51/4c642c0c14402f868ad37bc896bb25fb.png"
                                alt=""
                            />
                        </div>
                    </div>
                    <div class="status_wrap">
                        <span>{{ pagination.total }}条</span>
                    </div>
                    <div class="mobile_container invoice_management_container">
                        <div class="mobile_container_list">
                            <ul v-infinite-scroll="onLoadList">
                                <li
                                    class="payable_list_item"
                                    v-for="(row, index) in tableData"
                                    :key="index"
                                    @click.stop="handleClickInvoiceDetail(row)"
                                >
                                    <div class="payable_list_item_top">
                                        <template v-if="status == 4">
                                            <div
                                                class="mobile_list_head_user"
                                                @click.stop="handleClickUserInfo(row.salesperson_info)"
                                            >
                                                <img
                                                    :src="
                                                        row.salesperson_info && row.salesperson_info.avatar
                                                            ? row.salesperson_info.avatar
                                                            : defaultImg
                                                    "
                                                    alt=""
                                                />
                                                <span class="ellipsis">{{
                                                    row.salesperson_info && row.salesperson_info.name
                                                }}</span>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div
                                                class="mobile_list_head_user"
                                                @click.stop="handleClickUserInfo(row.apply_user_info)"
                                            >
                                                <img
                                                    :src="
                                                        row.apply_user_info && row.apply_user_info.avatar
                                                            ? row.apply_user_info.avatar
                                                            : defaultImg
                                                    "
                                                    alt=""
                                                />
                                                <span class="ellipsis">{{
                                                    row.apply_user_info && row.apply_user_info.name
                                                }}</span>
                                            </div>
                                            <span class="payable_list_item_top_time">
                                                <template v-if="status == 1">{{ row.apply_time }}</template>
                                                <template v-else-if="status == 2">{{ row.confirmed_at }}</template>
                                                <template v-else>{{ row.status == 3 ? row.reject_time : (row.status == 4 ? row.invalid_time : '--') }}</template>
                                            </span>
                                            <span
                                                v-if="status == 3"
                                                class="payable_list_item_status payable_list_item_status3"
                                                >{{
                                                    row.status == 3 ? "已驳回" : row.status == 4 ? "已作废" : "--"
                                                }}</span
                                            >
                                        </template>
                                    </div>
                                    <div class="payable_list_item_content">
                                        <template v-if="status == 4">
                                            <p>
                                                <span class="link-label" @click.stop="handleClickOrderDetail(row)">{{
                                                    row.order_num
                                                }}</span>
                                            </p>
                                            <p>
                                                <span
                                                    class="link-label"
                                                    @click.stop="
                                                        handleClickCustomerDetail(row.customer_id, row.customer_name)
                                                    "
                                                    >{{ row.customer_name }}</span
                                                >
                                            </p>
                                        </template>
                                        <template v-else>
                                            <p>
                                                <span class="link-label" @click.stop="handleClickInvoiceDetail(row)">{{
                                                    row.invoice_no
                                                }}</span>
                                                <span
                                                    class="handle_icon_wrap handle_icon_wrap_orange"
                                                    @click.stop="handleClickInvoiceRecord(row)"
                                                    v-if="row.invoiceLogInfo && row.invoiceLogInfo.length"
                                                >
                                                    <i class="iconfont icon-shenpizhong"></i>
                                                </span>
                                            </p>
                                            <p>
                                                <span
                                                    class="link-label"
                                                    @click.stop="
                                                        handleClickCustomerDetail(
                                                            row.customer_info && row.customer_info.id,
                                                            row.customer_info && row.customer_info.name
                                                        )
                                                    "
                                                    >{{ row.customer_info && row.customer_info.name }}</span
                                                >
                                            </p>
                                        </template>
                                        <div class="payable_list_item_amount">
                                            <template v-if="status == '4'">
                                                <div>
                                                    <div class="payable_list_item_amount_percent percent_bg1">
                                                        订单总金额：¥{{ row.total_price }}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="payable_list_item_amount_percent percent_bg2">
                                                        已回款金额：¥{{ row.total_repay_price }}
                                                    </div>
                                                    <div class="payable_list_item_amount_percent percent_bg4">
                                                        未回款金额：¥{{
                                                            Number(row.total_price - row.total_repay_price).toFixed(2)
                                                        }}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="payable_list_item_amount_percent percent_bg2">
                                                        已开票金额：¥{{ row.invoiced_amount }}
                                                    </div>
                                                    <div class="payable_list_item_amount_percent percent_bg3">
                                                        未开票金额：¥{{ row.un_invoice_amount }}
                                                    </div>
                                                </div>
                                            </template>
                                            <div v-else>
                                                <div class="payable_list_item_amount_percent percent_bg1">
                                                    开票金额：¥{{ row.invoice_amount }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="payable_list_item_bottom" v-if="status != '4'">
                                        <template v-if="status == '1'">
                                            <van-button
                                                plain
                                                size="mini"
                                                color="#2990FF"
                                                @click.stop="handleClickReject(row)"
                                                >驳回</van-button
                                            >
                                            <van-button
                                                size="mini"
                                                color="#2990FF"
                                                @click.stop="handleClickInvoiceConfirm(row)"
                                                >确认</van-button
                                            >
                                        </template>

                                        <template v-if="status == '2'">
                                            <van-button
                                                size="mini"
                                                color="#2990FF"
                                                @click.stop="handleClickInvalid(row)"
                                                >作废</van-button
                                            >
                                        </template>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>
                    <!-- 开票菜单类型选择 -->
                    <van-overlay
                        :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
                        class-name="custom_more_overlay"
                        v-if="showCategoryPicker"
                        :show="showCategoryPicker"
                        @click="showCategoryPicker = false"
                    >
                        <div class="radio_option_wrap">
                            <div class="radio_option_item" @click="handleClickCategoryPickerClose">
                                <span>开票分类</span>
                                <van-icon name="arrow-up" />
                            </div>
                            <ul class="radio_option_list">
                                <li
                                    class="radio_option_item"
                                    v-for="item in sourceList"
                                    :key="item.status"
                                    @click="handleClickStatusChange(item)"
                                >
                                    <span>{{ item.name }}</span>
                                    <van-icon name="success" v-if="status == item.status" />
                                </li>
                            </ul>
                        </div>
                    </van-overlay>
                    <!-- 驳回 -->
                    <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }" :show="rejectDialog">
                        <div class="custom_overlay_content">
                            <div class="custom_overlay_content_title">
                                <span>驳回原因</span>
                                <van-icon name="cross" @click="handleClickRejectClose" />
                            </div>
                            <div class="custom_overlay_content_form">
                                <van-field
                                    v-model="reject_reason"
                                    rows="6"
                                    autosize
                                    label=""
                                    type="textarea"
                                    maxlength="200"
                                    placeholder="请输入驳回原因"
                                />
                                <van-button color="#2990FF" @click="handleClickRejectConfirm">确定</van-button>
                            </div>
                        </div>
                    </van-overlay>
                    <!-- 作废 -->
                    <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }" :show="invalidDialog">
                        <div class="custom_overlay_content">
                            <div class="custom_overlay_content_title">
                                <span>作废原因</span>
                                <van-icon name="cross" @click="handleClickInvalidClose" />
                            </div>
                            <div class="custom_overlay_content_form">
                                <van-field
                                    v-model="invalid_reason"
                                    rows="6"
                                    autosize
                                    label=""
                                    type="textarea"
                                    placeholder="请输入作废原因"
                                />
                                <van-button color="#2990FF" @click="handleClickInvalidConfirm">确定</van-button>
                            </div>
                        </div>
                    </van-overlay>
                </div>
            </template>
        </PullContainer>
        <userDetailDialog
            v-if="userDetailPopupShow"
            :userDetailPopupShow.sync="userDetailPopupShow"
            :userId="userDetailId"
        />
        <ListAdvancedFiltering
            v-if="searchPopupShow"
            ref="listAdvancedFiltering"
            :system_fields="systemFilterFields[this.status]"
            @sendFilterData="getFilterData"
        />
    </div>
</template>
<script>
import { InvoiceList, InvoiceReject, OrderUnInvoiceList, InvoiceExceptionList, InvoiceInvalidate } from "@/api";
import { pagination } from "@/mixins";
import { mapState } from "vuex";
import { Dialog } from "vant";
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
import userDetailDialog from "@/components/mComponents/userDetailDialog";
import ListAdvancedFiltering from "../component/ListAdvancedFiltering.vue";
export default {
    name: "InvoiceManage",
    components: {
        PullContainer,
        ReturnNavBar,
        FooterTabbar,
        userDetailDialog,
        ListAdvancedFiltering,
    },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            searchForm: {
                keyword: "",
            },
            status: "1", // 分类类型
            sourceList: [
                { name: "待开票", status: "1" },
                { name: "已开票", status: "2" },
                { name: "异常开票", status: "3" },
                { name: "未开票", status: "4" },
            ],
            tableData: [
                {
                    id: 1,
                    invoice_no: "XBHSb111",
                    invoiceLogInfo: [
                        {
                            id: 1,
                            invoice_no: "XBHSb111",
                            time: "2024-09-18 14:52",
                            money: "40000",
                            invalid_reason: "作废原因",
                            invalid_time: "2024-09-18 14:52",
                        },
                    ],
                },
            ],
            showCategoryPicker: false,
            // 驳回
            rejectDialog: false,
            reject_reason: "",
            // 作废
            invalidDialog: false,
            invalid_reason: "",
            // 复选框选中的数据
            handleDialogIds: [],
            tabBarList: [
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "FinanceManagement",
                    title: "首页",
                },
                {
                    icon: "icon-mobile-yingfu",
                    activeIcon: "icon-mobile-yingfu",
                    routerName: "PayableManage",
                    title: "应付",
                },
                {
                    icon: "icon-yingshou",
                    activeIcon: "icon-yingshouxuanzhong",
                    routerName: "ReceivableManage",
                    title: "应收",
                },
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "InvoiceManage",
                    title: "开票",
                },
            ],
            tabBarActive: 3,
            // 人员详细信息
            userDetailPopupShow: false,
            userDetailId: "",
            // 筛选条件
            systemFilterFields: {
                1: [
                    {
                        field_type: "contact",
                        field_key: "apply_uid",
                        is_system: 1,
                        field_name: "申请人",
                        system_type: "system",
                        field_value_type: "array",
                    },
                    {
                        field_type: "date_range",
                        field_key: "apply_time",
                        is_system: 1,
                        field_name: "申请发票日期",
                        system_type: "system",
                        field_value_type: "array",
                    },
                    {
                        field_type: "checkbox",
                        field_key: "invoice_type",
                        is_system: 1,
                        field_name: "发票类型",
                        system_type: "system",
                        options: [
                            { value: 1, label: "电子专票" },
                            { value: 2, label: "电子普票" },
                            { value: 3, label: "纸质专票" },
                            { value: 4, label: "纸质普票" },
                        ],
                        field_value_type: "int",
                    },
                ],
                2: [
                    {
                        field_type: "contact",
                        field_key: "apply_uid",
                        is_system: 1,
                        field_name: "申请人",
                        system_type: "system",
                        field_value_type: "array",
                    },
                    {
                        field_type: "date_range",
                        field_key: "apply_time",
                        is_system: 1,
                        field_name: "申请发票日期",
                        system_type: "system",
                        field_value_type: "array",
                    },
                    {
                        field_type: "date_range",
                        field_key: "invoice_time",
                        is_system: 1,
                        field_name: "财务开票日期",
                        system_type: "system",
                        field_value_type: "array",
                    },
                    {
                        field_type: "checkbox",
                        field_key: "invoice_type",
                        is_system: 1,
                        field_name: "发票类型",
                        system_type: "system",
                        options: [
                            { value: 1, label: "电子专票" },
                            { value: 2, label: "电子普票" },
                            { value: 3, label: "纸质专票" },
                            { value: 4, label: "纸质普票" },
                        ],
                        field_value_type: "int",
                    },
                ],
                3: [
                    {
                        field_type: "contact",
                        field_key: "apply_uid",
                        is_system: 1,
                        field_name: "申请人",
                        system_type: "system",
                        field_value_type: "array",
                    },
                    {
                        field_type: "date_range",
                        field_key: "apply_time",
                        is_system: 1,
                        field_name: "申请发票日期",
                        system_type: "system",
                        field_value_type: "array",
                    },
                    {
                        field_type: "checkbox",
                        field_key: "invoice_type",
                        is_system: 1,
                        field_name: "发票类型",
                        system_type: "system",
                        options: [
                            { value: 1, label: "电子专票" },
                            { value: 2, label: "电子普票" },
                            { value: 3, label: "纸质专票" },
                            { value: 4, label: "纸质普票" },
                        ],
                        field_value_type: "int",
                    },
                    {
                        field_type: "date_range",
                        field_key: "reject_time",
                        is_system: 1,
                        field_name: "驳回日期",
                        system_type: "system",
                        field_value_type: "array",
                    },
                    {
                        field_type: "date_range",
                        field_key: "invalid_time",
                        is_system: 1,
                        field_name: "作废日期",
                        system_type: "system",
                        field_value_type: "array",
                    },
                    {
                        field_type: "checkbox",
                        field_key: "status",
                        is_system: 1,
                        field_name: "异常状态",
                        system_type: "system",
                        options: [
                            { value: 3, label: "已驳回" },
                            { value: 4, label: "已作废" },
                        ],
                        field_value_type: "int",
                    },
                ],
            },
            custom_filter: {}, // 高级筛选确认条件
        };
    },
    mixins: [pagination],
    computed: {
        ...mapState(["searchPopupShow"]),
    },
    mounted() {
        this.status = (this.$route.query && this.$route.query.status) ? String(this.$route.query.status) : "1";
        this.tableData = [];
        this.onSearch();
    },
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true;
                this.onSearch();
            }
        },
        // 点击高级筛选
        handleClickAdvancedFilter() {
            this.$store.dispatch("searchPopupShow", true);
        },
        // 获取高级筛选数据
        getFilterData(data) {
            this.custom_filter = data;
            this.$store.dispatch("searchPopupShow", false);
            this.onSearch();
        },
        // 分类切换弹框
        handleClickCategoryPickerShow() {
            this.showCategoryPicker = true;
        },
        // 分类切换
        handleClickStatusChange(item) {
            this.status = item.status;
            this.showCategoryPicker = false;
            this.onSearch();
        },
        // 批量操作
        handleClickBatch() {
            this.$router.push({
                name: "InvoiceChoose",
            });
        },
        // 驳回
        handleClickReject(row) {
            this.handleDialogIds = [row.invoice_no];
            this.rejectDialog = true;
        },
        // 驳回弹框关闭
        handleClickRejectClose() {
            this.handleDialogIds = [];
            this.reject_reason = "";
            this.rejectDialog = false;
        },
        // 驳回确认
        handleClickRejectConfirm() {
            if (!this.reject_reason) return this.$toast("请输入驳回原因");
            InvoiceReject({ invoice_nos: this.handleDialogIds, reject_reason: this.reject_reason }).then((res) => {
                if (res.code == 200) {
                    this.$toast({
                        message: res.message,
                        type: "success",
                        duration: 1000,
                        onClose: () => {
                            this.handleClickRejectClose();
                            this.onSearch();
                        },
                    });
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 作废
        handleClickInvalid(row) {
            this.handleDialogIds = row.invoice_no;
            this.invalidDialog = true;
        },
        // 作废弹框关闭
        handleClickInvalidClose() {
            this.invalidDialog = false;
            this.handleDialogIds = [];
            this.invalid_reason = "";
        },
        // 作废确认
        handleClickInvalidConfirm() {
            if (!this.invalid_reason) return this.$toast("请输入作废原因");
            InvoiceInvalidate({ invoice_no: this.handleDialogIds[0], invalid_reason: this.invalid_reason }).then(
                (res) => {
                    if (res.code == 200) {
                        this.$toast({
                            message: res.message,
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                this.handleClickInvalidClose();
                                this.onSearch();
                            },
                        });
                    } else {
                        this.$message.error(res.message);
                    }
                }
            );
        },
        // 开票确认
        handleClickInvoiceConfirm(row) {
            this.$router.push({
                name: "InvoiceConfirmation",
                query: {
                    invoice_no: row.invoice_no,
                }
            });
        },
        // 详情
        handleClickInvoiceDetail(row) {
            if (this.status == 4) return false;
            this.$router.push({
                name: "InvoiceDetails",
                query: {
                    invoice_no: row.invoice_no,
                    status: this.status,
                },
            });
        },
        // 订单详情
        handleClickOrderDetail(row) {
            console.log(row.order_num);
        },
        // 关联开票记录
        handleClickInvoiceRecord(row) {
            this.$router.push({
                name: "InvoiceRecord",
                query: {
                    invoice_no: row.invoice_no,
                },
            });
        },
        // 人员详细信息
        handleClickUserInfo(info) {
            this.userDetailId = info.id;
            this.userDetailPopupShow = true;
        },
        onSearch() {
            this.pagination.pageNum = 1;
            this.tableData = [];
            this.getMoreTypeData();
        },
        // 加载更多
        onLoadList() {
            if (this.pagination.total == this.tableData.length) {
                return false;
            }
            if (this.loading == false) {
                this.getMoreTypeData();
            }
        },
        // 加载数据
        getMoreTypeData() {
            if (this.status == 1 || this.status == 2) {
                this.getInvoiceList();
            } else if (this.status == 3) {
                this.getInvoiceExceptionList();
            } else {
                this.getOrderUnInvoiceList();
            }
        },
        // 待开票和已开票列表
        getInvoiceList() {
            this.loading = true;
            let params = {
                page: this.pagination.pageNum,
                pageSize: 10, // this.pagination.pageSize
                status: this.status,
            };
            if (this.custom_filter.custom_field && this.custom_filter.custom_field.length) {
                this.custom_filter.custom_field.forEach((option) => {
                    params[option.field_key] =
                        option.field_value_type == "int" ? option.field_value[0] : option.field_value;
                });
            }
            InvoiceList(params)
                .then((res) => {
                    if (res.code == 200) {
                        const { data, total } = res.data;
                        this.tableData = this.tableData.concat(data);
                        this.pagination.total = total;
                        this.pagination.pageNum++;
                        this.loading = false;
                        if (this.pullDownLoading) {
                            this.pullDownLoading = false;
                            this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                        }
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 未开票列表
        getOrderUnInvoiceList() {
            this.loading = true;
            let params = {
                page: this.pagination.pageNum,
                pageSize: 10, // this.pagination.pageSize
                keyword: this.searchForm.keyword,
            };
            OrderUnInvoiceList(params)
                .then((res) => {
                    if (res.code == 200) {
                        const { data, total } = res.data;
                        this.tableData = this.tableData.concat(data);
                        this.pagination.total = total;
                        this.pagination.pageNum++;
                        this.loading = false;
                        if (this.pullDownLoading) {
                            this.pullDownLoading = false;
                            this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                        }
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 异常开票列表（已驳回、已作废）
        getInvoiceExceptionList() {
            this.loading = true;
            let params = {
                page: this.pagination.pageNum,
                pageSize: 10, // this.pagination.pageSize
                keyword: this.searchForm.keyword,
            };
            if (this.custom_filter.custom_field && this.custom_filter.custom_field.length) {
                this.custom_filter.custom_field.forEach((option) => {
                    params[option.field_key] =
                        option.field_value_type == "int" ? option.field_value[0] : option.field_value;
                });
            }
            InvoiceExceptionList(params)
                .then((res) => {
                    if (res.code == 200) {
                        const { data, total } = res.data;
                        this.tableData = this.tableData.concat(data);
                        this.pagination.total = total;
                        this.pagination.pageNum++;
                        this.loading = false;
                        if (this.pullDownLoading) {
                            this.pullDownLoading = false;
                            this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                        }
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 查看客户详情
        handleClickCustomerDetail(customer_id, customer_name) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id,
                    name: customer_name,
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.returnNavBarRight {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 22px;
    color: rgba(41, 144, 255, 1);
}
.all_menu_list {
    margin-top: -4px;
    height: 42px;
    opacity: 1;
    background: rgba(255, 255, 255, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    ul {
        height: 100%;
        padding: 0 7px 0 16px;
        overflow-x: auto;
        display: flex;
        gap: 10px;
        li {
            flex: auto;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 42px;
            color: rgba(102, 102, 102, 1);
            text-align: center;
            white-space: nowrap;
            position: relative;
            span {
                line-height: 22px;
            }
            &.active {
                font-weight: 700;
                color: rgba(25, 144, 255, 1);
                &::after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    margin-left: -10px;
                    width: 20px;
                    height: 2px;
                    border-radius: 1px 1px, 0px, 0px;
                    background: rgba(41, 144, 255, 1);
                }
            }
            .count {
                position: absolute;
                top: 5px;
                right: 1px;
                padding: 0 4px;
                min-width: 18px;
                height: 18px;
                line-height: 16px;
                text-align: center;
                border: 1px solid #ffffff;
                font-size: 10px;
                font-weight: 500;
                color: #ffffff;
                border-radius: 10px;
                background-color: rgb(228, 65, 68);
            }
        }
    }
    .all_menu_filter_icon {
        flex-shrink: 0;
        padding: 0 16px;
        img {
            width: 16px;
        }
    }
}
.radio_option_wrap {
    width: 100%;
    min-height: 220px;
    max-height: 50%;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    .radio_option_item {
        padding: 10px 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(51, 51, 51, 1);
        }
        .van-icon {
            color: rgba(51, 51, 51, 1);
            font-size: 12px;
        }
    }
    .radio_option_list {
        flex: 1;
        overflow-y: auto;
        .radio_option_item {
            span {
                color: rgba(102, 102, 102, 1);
            }
            .van-icon {
                color: rgba(25, 144, 255, 1);
            }
        }
    }
}
.custom_more_overlay {
    top: 44px !important;
}
.status_wrap {
    padding: 10px 16px 8px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    & > div {
        span {
            display: inline-block;
            vertical-align: top;
            width: 68px;
            height: 26px;
            text-align: center;
            line-height: 26px;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            color: rgba(102, 102, 102, 1);
            border-radius: 4px;
            background: rgba(255, 255, 255, 1);
            & + span {
                margin-left: 10px;
            }
            &.active {
                color: rgba(41, 144, 255, 1);
                border: 1px solid rgba(41, 144, 255, 0.5);
                background: rgba(41, 144, 255, 0.1);
            }
        }
    }
    & > span {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 18px;
        color: rgba(153, 153, 153, 1);
    }
}
.invoice_management_container {
    .mobile_container_list {
        padding: 0 16px 8px;
        .payable_list_item {
            width: 100%;
            padding: 12px;
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            margin-bottom: 8px;
            .payable_list_item_top {
                padding-bottom: 10px;
                display: flex;
                align-items: center;
                position: relative;
                & > span {
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 18px;
                    color: rgba(153, 153, 153, 1);
                }
                .link-label {
                    color: rgba(41, 144, 255, 1);
                }
                .payable_list_item_status {
                    position: absolute;
                    top: 2px;
                    right: 0;
                    width: 52px;
                    height: 22px;
                    text-align: center;
                    line-height: 22px;
                    font-size: 12px;
                    font-weight: 400;
                    border-radius: 6px;
                    &.payable_list_item_status1 {
                        color: rgba(240, 170, 50, 1);
                        background: rgba(240, 170, 50, 0.15);
                    }
                    &.payable_list_item_status2 {
                        color: rgba(90, 179, 51, 1);
                        background-color: rgba(90, 179, 51, 0.15);
                    }
                    &.payable_list_item_status3,
                    &.payable_list_item_status_unpaid,
                    &.payable_list_item_status_badDebt,
                    &.payable_list_item_status_invalid {
                        color: rgba(153, 153, 153, 1);
                        background-color: rgba(153, 153, 153, 0.15);
                    }
                }
            }
            .payable_list_item_content {
                p {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(102, 102, 102, 1);
                    margin-bottom: 4px;
                    .link-label {
                        color: rgba(41, 144, 255, 1);
                    }
                }
                .payable_list_item_amount {
                    width: 100%;
                    padding: 4px;
                    border-radius: 4px;
                    background: #ffffff;
                    border: 2px solid rgba(237, 240, 244, 1);
                    & > div {
                        height: 24px;
                        display: flex;
                        justify-content: space-between;
                        gap: 4px;
                    }
                    & > div + div {
                        margin-top: 4px;
                    }
                    .payable_list_item_amount_percent {
                        width: 100%;
                        height: 24px;
                        padding: 0 8px;
                        font-size: 12px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 24px;
                        color: rgba(102, 102, 102, 1);
                        border-radius: 4px;
                        box-sizing: border-box;
                    }
                    .percent_bg1 {
                        background-color: rgba(41, 144, 255, 0.16);
                    }
                    .percent_bg2 {
                        background-color: rgba(41, 144, 255, 0.08);
                        padding-right: 0;
                    }
                    .percent_bg3 {
                        background-color: rgba(228, 65, 68, 0.08);
                        color: rgba(228, 65, 68, 1);
                        font-weight: 700;
                        text-align: right;
                        padding-left: 0;
                    }
                    .percent_bg4 {
                        background-color: rgba(0, 0, 0, 0.04);
                        color: rgba(51, 51, 51, 1);
                        font-weight: 700;
                        text-align: right;
                        padding-left: 0;
                    }
                }
                .handle_icon_wrap_orange {
                    margin-left: 4px;
                    color: rgba(240, 170, 50, 1);
                }
            }
            .payable_list_item_bottom {
                margin-top: 10px;
                display: flex;
                justify-content: flex-end;
                .van-button {
                    padding: 0 7px;
                    border-radius: 4px;
                    font-size: 12px;
                }
            }
        }
    }
}
</style>
